
import { BreakpointObserver } from '@angular/cdk/layout';
import { StepperOrientation, STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { Component, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { environment } from '../../../../src/environments/env';
import { SppdashboardService } from './sppdashboard.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserDataModalComponent } from 'src/app/component/user-data-modal/user-data-modal.component';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { employmentTypeList } from 'src/app/utils/constants';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { PreSubmissionModalComponent } from 'src/app/component/pre-submission-modal/pre-submission-modal.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  standalone: false,
  styleUrl: './dashboard.component.scss',

  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false, showError: true },
    }
  ]
})
export class DashboardComponent implements OnInit, OnDestroy {

  icons = {
    faArrowLeft,
    faInfoCircle
  }

  public iscpProviderList: any = [];
  public languageList: any = [];
  public countryList: any = [];
  public timezoneList: any = [];
  public status: any = '';
  public email: any = '';
  public show: boolean = false;
  public dialogConfig: any = {};
  public stepperOrientation!: Observable<StepperOrientation>;
  public snackbar = inject(MatSnackBar);
  public simpleDialog!: MatDialogRef<UserDataModalComponent>;
  isFromRenewal: boolean | null = null;
  isDashboardForm: boolean = true;
  private statusCheckInterval: any;
  private loggedUserDetails: any;
  userSelectedFlow: string = '';


  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChild('stepperLin') stepperLin!: MatStepper;

  public constructor(
    private readonly router: Router,
    breakpointObserver: BreakpointObserver,
    private readonly _auth: AuthService,
    private readonly sppdashboardService: SppdashboardService,
    private readonly dialogModel: MatDialog,
  ) {
    this.stepperOrientation = breakpointObserver
      .observe('(min-width: 600px)')
      .pipe(map(({ matches }) => (matches ? 'horizontal' : 'vertical')));
  }

  public employmentTypeList: any = employmentTypeList;

  ngOnInit() {
    // EXTRACTION OF THE PARAM PASSED FROM ROUTING
    const state = window.history.state;

    // Get the Logged in user Details
    this._auth.getLoggedInUserDetails()
      .pipe(distinctUntilChanged((prev: any, curr: any) => JSON.stringify(prev) === JSON.stringify(curr)))
      .subscribe((res: any) => {
        if (res) {
          this.loggedUserDetails = res;
          if (this.loggedUserDetails.status === 'ILT_OPEN') {
            this.userSelectedFlow = 'ILTFlow';
          } else if (this.loggedUserDetails.status === 'OPEN' || this.loggedUserDetails.status === 'REJECT') {
            // this.show = true;
            // || this.loggedUserDetails.status === 'TEST_OUT_OPEN'
            this.userSelectedFlow = 'ISCPFlow';
          } else {
            this.userSelectedFlow = '';
          }
        }
      });



    this.dialogConfig = {
      type: 'delete',
      forComponent: 'Announcement',
      value: ''
    }
    this.email = sessionStorage.getItem('email')
    this.status = sessionStorage.getItem('status') || '';

    // second condion is added so if user is redirected back from payment screen this modal should not appear again
    if ((this.status === 'FIRST_LOGIN' || this.status === 'EXPIRED') && !state?.skipForm) {

      let dialogRef;
      if (state.source === 'mct-renewal') {
        dialogRef = this.dialogModel.open(PreSubmissionModalComponent, {
          data: {
            userstage: 'FTE_USER'
          }
        });
      } else if (state.source === 'less-than-three') {
        // Handle the case for less-than-three years expired to show the ISCP flow
        this.userSelectedFlow = 'ISCPFlow';
        this.show = true;
      } else {
        dialogRef = this.dialogModel.open(PreSubmissionModalComponent, {});
      }


      dialogRef?.afterClosed().subscribe((value) => {
        if (value === 'ISCPFlow' || value === 'ILTFlow') {
          this.userSelectedFlow = value;
          this.show = true;
        } else {
          // Handle the 'no' case - Logout the User
          this._auth.changeMessage('default message');
          if (localStorage.getItem('SPP') === 'true') {
            localStorage.removeItem('SPP');
          }
          setTimeout(() => { window.open(environment.BASE_URL + "/ptp/security/ssoLogout?entryPoint=" + environment.APP_URL + "/#/prelogin", '_self') }, 300);
        }
      })
    } else if (this.status === 'ILT_OPEN') {
      this.show = true;
    } else if ((this.status === 'TEST_OUT_FAIL' || (this.status === 'TEST_OUT_OPEN' && sessionStorage.getItem('endDate') != "null") || this.status === 'ILT_FAIL') && !state?.skipForm) {
      this.showModalTextForFailCase(this.status);
    } else {
      this._auth.currentUser$.subscribe((message: any) => {
        if (message === 'open' || message === 'no_submit' || message === 'reject') {
          this.show = true;
        }
      })
    }

    this.getIscpProviderList();
    this.getLanguageList();
    this.getCountryList();

    if (state?.skipForm === true) {
      this.showILTSessionList();
      // Keep checking the status as comming back from payment
      this.keepcheckingStatus();
    }

    if (state?.source === 'mct-renewal') {
      this.isFromRenewal = true;
    } else if (state?.source === 'greater-than-three') {
      this.show = true;
    }


    this.statusCheckInterval = setInterval(() => {
      this.sppdashboardService.getUser().subscribe((res: any) => {
        //this.redirectHomeOnTestout(res);
         const status = res?.data?.status || '';
        if (status === 'TEST_OUT_OPEN') {
          this.router.navigate(['/home']);
        }
      })
    }, 500);
  

  }

  // redirectHomeOnTestout(res: any) {
  //   if (res?.data?.status === 'TEST_OUT_OPEN') {
  //     this.router.navigate(['/home']);
  //   }
  // }


  showModalTextForFailCase(status: string) {
    let res: any = {};
    if (status === 'ILT_FAIL') {
      res.message = `Thank you for your interest in becoming a Microsoft Certified Trainer. We appreciate the time and effort you have invested in our MCT Onboarding Experience.
                    After carefully reviewing your results, we regret to inform you that you have not successfully completed the MCT Onboarding Course. 
                    As a courtesy, you have the opportunity to re-take the course at a 50% discount. To re-enroll in the course, 
                    please proceed to the next screen.`;
      res.title = 'MCT Onboarding Experience: Training Result';
    }

    if (status === 'TEST_OUT_FAIL') {
      res.message = `Thank you for your interest in becoming a Microsoft Certified Trainer and 
                      for the time and effort you have invested in the MCT Instructional Skills Assessment.
                        <br/><br/> 
                      After carefully reviewing your results, we regret to inform you that you did not receive a passing score 
                      on the assessment. While we are unable to proceed with your application, 
                      we are pleased to offer you an alternative pathway to becoming an MCT.
                        <br/><br/>
                      If you are interested, please register for the MCT Onboarding Experience on next page.`;
      res.title = 'MCT Instructional Skills Assessment Result';
    }

    // Test out Open case from the Renewal Reject-> fail from the Admin.
     if (status === 'TEST_OUT_OPEN') {
      res.message = `<p>Thank you for completing the MCT Renewal Assessment. We appreciate the time and effort you invested in this process.
                        <br/><br/> 
                        Unfortunately, you did not achieve a passing score on the MCT Renewal Assessment and are therefore not eligible to renew your MCT status through the assessment pathway.
                        <br/><br/>
                        To regain MCT status, you must re-enter the program by successfully completing the fee-based <span style="font-weight: 600;">MCT Instructional Skills Assessment.</span>
                        <br/><br/>
                        To learn more, please proceed to the next page.
                        <br/><br/>
                      For questions, please contact us at <a href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com.</a> - we’re here to help!</p>`;
      res.title = 'MCT Renewal Assessment Result Update';
    }


    const resp = {
      message: res.message,
      title: res.title,
      data: {
        status: "TEST_OUT_FAIL"
      }
    }
    this.dialogConfig.value = resp
    this.simpleDialog = this.dialogModel.open(UserDataModalComponent, { data: this.dialogConfig });

    this.simpleDialog.afterClosed().subscribe({
      next: (result) => {
        if (result) {
          if (result === 'trainingSelection') {
            //  control to display training selection component
            this.showILTSessionList();
          }
        }
      },
      error: (error) => {
        console.error('Error in dialog:', error);
      },
      complete: () => {
        console.log('Dialog closed');
      }
    });

  }

  keepcheckingStatus() {
    this.statusCheckInterval = setInterval(() => {
      this.sppdashboardService.getUser().subscribe((res: any) => {
        const status = res?.data?.status || '';
        if (status === 'ILT_PAYMENT') {
          this.router.navigate(['/home']);
        }
      })
    }, 500);
  }


  getCountryList = () => {
    this.sppdashboardService.getCountryList().subscribe((response: any) => {
      this.countryList = response;
    }, (error: any) => {
      console.error("Error fetching Country List", error);
    });
  }


  getIscpProviderList = () => {
    this.sppdashboardService.getIscpProviderList('', '').subscribe((response: any) => {
      if (response.success) {
        this.iscpProviderList = response.data.content;
      } else {
        console.log("Error fetching ISCP Provider List");
      }
    }, (error: any) => {
      console.error("Error fetching ISCP Provider List", error);
    });
  }

  getLanguageList = () => {
    this.sppdashboardService.getLanguageList().subscribe((response: any) => {
      this.languageList = response;
    }, (error: any) => {
      console.error("Error fetching Language List", error);
    });
  }


  terms = () => {
    const termsUrl = 'https://www.pearson.com/terms-and-conditions.html';
    window.open(termsUrl, '_blank');
  }

  private showILTSessionList(): void {
    this.isDashboardForm = false;
    requestAnimationFrame(() => this.scrollMainPageToTop());
  }

  private scrollMainPageToTop(): void {
    const iltSessionHeader = document.getElementById('iltSessionHeader');

    if (iltSessionHeader) {
      iltSessionHeader.scrollIntoView({ behavior: 'auto', block: 'start' });
      return;
    }

    const pageTopWrapper = document.getElementsByClassName('sessionListWrapper');

    if (pageTopWrapper.length > 0) {
      (pageTopWrapper[0] as HTMLElement).scrollIntoView({ behavior: 'auto', block: 'start' });
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }

  // private onLoggedUserDetailsLoaded(): void {
  //   // Put any logic here that depends on logged-in user details being present.
  //   // console.log('#loggedUserDetails-ready', this.loggedUserDetails);
  // }

  toggleILTSessionList() {
    this.showILTSessionList();
  }

  ngOnDestroy(): void {
    // Clear the interval when component is destroyed
    if (this.statusCheckInterval) {
      clearInterval(this.statusCheckInterval);
    }
  }

}